export const homeObjOne = {
  id: "about",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "Tool Number 1",
  headline: "Have A Clear Agenda",
  description:
    "The main purpose of the agenda is to help students organize and schedule their busy lives, we make it easy for them!",
  buttonLabel: "Get started",
  imgStart: true,
  img: require("../../images/svg-1.svg").default,
  alt: "Agenda",
  dark: true,
  primary: true,
  darkText: false,
};

export const homeObjTwo = {
  id: "discover",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "Tool Number 2",
  headline: "Create A Direct Budget",
  description:
    "Budgeting can help you make better financial decisions, and stay focused on your long-term financial goals.",
  buttonLabel: "Get started",
  imgStart: false,
  img: require("../../images/svg-4.svg").default,
  alt: "Agenda",
  dark: false,
  primary: true,
  darkText: false,
};

export const homeObjThree = {
  id: "signup",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "Tool Number 3",
  headline: "Converse With The Community",
  description:
    "Having an online conversation tool really provides individuals with the ability to ask for help or advice.",
  buttonLabel: "Get started",
  imgStart: true,
  img: require("../../images/svg-3.svg").default,
  alt: "Agenda",
  dark: true,
  primary: true,
  darkText: false,
};

export const homeObjFour = {
  id: "notes",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "Tool Number 4",
  headline: "Have a secure Vault",
  description:
    "Having a vault with google protection to store and access videos, documents and images with great ease is one of our major successes.",
  buttonLabel: "Get started",
  imgStart: false,
  img: require("../../images/svg-5.svg").default,
  alt: "Agenda",
  dark: false,
  primary: true,
  darkText: false,
};
